
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { SpecialtyItemProps } from ".";
import { loading, index, options } from "store/specialty";

interface ApiSpecialtyInputProps {
    page: number;
    pageSize: number;
    q?: string;
}

type ApiSpecialtyOutputProps = OutputBaseProps<{ list: SpecialtyItemProps[]; pagination?: PaginationProps; }>;

export const apiSpecialtyIndex = async (data: ApiSpecialtyInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiSpecialtyOutputProps>("/api/specialties", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiSpecialtyOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiSpecialtyOutputProps>("/api/specialties", { params: { ...data, fields: "id,code,name,thumbnailUrl,description" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};